<template>
  <q-page>
    <Tema :id="id" />
  </q-page>
</template>

<script setup>
import Tema from "../components/irdr/Tema.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
const route = useRoute();
const id = computed(() => route.params?.id);
</script>